/* eslint-disable */
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Source = exports.Sorting = exports.SiteMemberStatus = exports.SiteMemberPrivacyStatus = exports.Role = void 0;
var Role;
(function (Role) {
    Role["UNDEFINED_ROLE"] = "UNDEFINED_ROLE";
    Role["MEMBER"] = "MEMBER";
    Role["OWNER"] = "OWNER";
    Role["CONTRIBUTOR"] = "CONTRIBUTOR";
})(Role = exports.Role || (exports.Role = {}));
var SiteMemberPrivacyStatus;
(function (SiteMemberPrivacyStatus) {
    SiteMemberPrivacyStatus["UNDEFINED"] = "UNDEFINED";
    SiteMemberPrivacyStatus["PUBLIC"] = "PUBLIC";
    SiteMemberPrivacyStatus["PRIVATE"] = "PRIVATE";
    SiteMemberPrivacyStatus["COMMUNITY"] = "COMMUNITY";
})(SiteMemberPrivacyStatus = exports.SiteMemberPrivacyStatus || (exports.SiteMemberPrivacyStatus = {}));
var SiteMemberStatus;
(function (SiteMemberStatus) {
    SiteMemberStatus["UNDEFINED_STATUS"] = "UNDEFINED_STATUS";
    SiteMemberStatus["APPLICANT"] = "APPLICANT";
    SiteMemberStatus["ACTIVE"] = "ACTIVE";
    SiteMemberStatus["INACTIVE"] = "INACTIVE";
    SiteMemberStatus["BLOCKED"] = "BLOCKED";
    SiteMemberStatus["OFFLINE_ONLY"] = "OFFLINE_ONLY";
})(SiteMemberStatus = exports.SiteMemberStatus || (exports.SiteMemberStatus = {}));
var Sorting;
(function (Sorting) {
    Sorting["DESC"] = "DESC";
    Sorting["ASC"] = "ASC";
})(Sorting = exports.Sorting || (exports.Sorting = {}));
var Source;
(function (Source) {
    Source["UNKNOWN"] = "UNKNOWN";
    Source["HANDLING_SPAM"] = "HANDLING_SPAM";
})(Source = exports.Source || (exports.Source = {}));
//# sourceMappingURL=types.js.map